module.exports = __webpack_public_path__ + "static/media/7S.82d62864.png";